import { CurrencyType } from '../../Wallet/Types/Wallet'

export interface DealDto {
  id: string
  ticket: number
  tradingAccount: {
    id: string
    name: string
  }
  tradingAccountType: {
    id: number
    name: string
  }
  tickmillCompany: {
    id: number
    name: string
  }
  client: {
    id: string
    name: string
    country: {
      id: string
      name: string
    }
  }
  instrument: {
    id: string
    name: string
  }
  introducingBroker: {
    id: string
    name: string
  }
  currency: {
    id: CurrencyType
    name: string
  }
  volume: number
  amount: number
  walletTransactionId: string | null
  createdAt: string
  tradedAt: string
  state: string | null
}

export enum DealDtoKey {
  id = 'id',
  ticket = 'ticket',
  introducingBroker = 'introducingBroker.name',
  affiliateToken = 'client.affiliateToken',
  tradingAccount = 'tradingAccount.name',
  tickmillCompany = 'tickmillCompany.name',
  client = 'client.name',
  instrument = 'instrument.name',
  currency = 'currency.id',
  volume = 'volume',
  amount = 'amount',
  walletTransaction = 'walletTransactionId',
  walletTransactionReference = 'walletTransactionReference',
  createdAt = 'createdAt',
  tradedAt = 'tradedAt',
  state = 'state',
}

export const isDealsWalletTransactionReference = (dealKey: string | undefined): boolean => {
  return dealKey === DealDtoKey.walletTransactionReference
}

export enum DealDtoFilterKey {
  introducingBroker = 'IntroducingBroker',
  introducingBrokerName = 'IntroducingBrokerName',
  tradingAccount = 'TradingAccount',
  tradingAccountName = 'TradingAccountName',
  affiliateToken = 'AffiliateToken',
  client = 'Client',
  walletTransaction = 'WalletTransactionReferenceId',
  tickmillCompany = 'TickmillCompanyId',
  createdAt = 'DateFrom',
  tradedAt = 'DateTo',
}

export enum DealDtoSortKey {
  tradingAccount = 'TradingAccount',
  client = 'ClientName',
  affiliateToken = 'TradingAccount.ClientTradingAccount.Wallet.Client.AffiliateToken',
  tradingAccountType = 'TradingAccountTypeName',
  tradedAt = 'TradedAt',
  instrument = 'InstrumentName',
  volume = 'Volume',
  amount = 'Amount',
  currency = 'CurrencyId',
}
